module.exports = __webpack_public_path__ + "img/eliminate.072bb553.png";